export default {
  Text: 'Text',
  Type: 'Type',
  Target: 'Target',
  Generate: 'Generate',
  Generating: 'Generating',
  optimize_text: {
    des: 'Al-Enhanced writing precision with natural flow',
    Save_and_New: 'Save and New'
  }
}
